const translations = {
    address: 'Address',
    grower: 'Grower',
    name: 'Name',
    phone: 'Phone'
};

export default translations;
